import { ResourceType } from 'json-api-hooks';
import React, { FC } from 'react';

import { ResourceFormProps } from '../components/./Form/ResourceForm';
import CardContent from '../components/Card/CardContent';
import CardMain from '../components/Card/CardMain';
import Container from '../components/Container';
import Heading from '../components/Heading';
import { ModalProps } from '../components/Modal/ModalContextProvider';

export type UpdateResourceModalProps<T extends ResourceType> = ModalProps<{
  label: string;
  id: string;
  form: FC<Partial<ResourceFormProps<T>>>;
  type: T;
}>;

const UpdateResourceModal = <T extends ResourceType>({
  form: Form,
  handleClose,
  id,
  label,
  type,
}: UpdateResourceModalProps<T>) => {
  return (
    <Container>
      <CardMain>
        <CardContent endSpacing>
          <Heading>{label}</Heading>
          <Form id={id} type={type} onClose={handleClose} onSuccess={handleClose} />
        </CardContent>
      </CardMain>
    </Container>
  );
};

export default UpdateResourceModal;
